import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import ContainerButton from '../../../components/button/ContainerButton';
import StateComponents from '../../../components/state-component/StateComponents';
import ImageTracking from '../../../components/upload/MultiUploadFile';
import { ManageStateComplaintSubmitDetail } from './manageStateComplaintSubmitDetail';
import { ComplaintPublishStatus, ComplaintPublishStatusData, COMPLAINTS_STATUS, COMPLAINTS_STATUS_DATA, status_image_infer, status_log_check, status_meeting_check, status_not_receive_check, status_receive_check } from './enum/complaint.enum';
import { useTranslation } from 'react-i18next';
import { languageEnum } from '../../../constants/enum';
import StatusCustom from '../../../components/status/statusCustom';
import moment from 'moment';
import ModalCustom from '../../../components/modal/ModalCustom';
import TableCustom from '../../../components/table/tableCustom';
import { Tabs, Typography } from '@mui/material';
import { colors } from '../../../constants/colors';
import { CustomTab, projectTabsProps } from './enum/TabCustom';

type Props = {
    view: boolean;
    cms?: boolean;
    handleApprove?: (id_complaints: number, callback?: () => void) => void;
    handleReject?: (id_complaints: number, callback?: () => void) => void;
}

const ComplaintSubmitDetail: React.FC<Props> = ({ view, cms, handleApprove, handleReject }: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const currentLanguage: string = i18n.language;
    const [searchParams] = useSearchParams();
    const checkStatistics = searchParams.get("statistics");



    const {
        formState,
        handleChangeFormState,
        // profile,
        handleSubmit,
        handleChangeImage,
        image_data,
        status,
        step,
        set_step,
        complaint_type_data,
        id_complaints_type,
        set_id_complaints_type,
        complaints_files,
        handleDeleteImageUploadFile,
        handleDeleteImageApi,
        handleGetFile,
        dataDetail,
        show_time_line,


        page,
        pageLimit,
        handleRequestSort,
        setPage,
        setPageLimit,
        sortType,
        sortBy,
        totalItems,
        headCells,
        data_time_line,
        renderData,
        handleOpenModal,
        handleCloseModal,

        handleChangeImageInfer,
        file_infer,
        file_infer_api,
        remark,
        set_remark,
        handleSubmitInfer,
        handleGetDetail,
        handleApproveAndRejectInfer,
        handleSendMeeting,
        handleDeleteImageUploadFileInfer,
        handleDownloadFile,



        pageMeeting,
        pageLimitMeeting,
        setPageMeeting,
        setPageLimitMeeting,
        handleRequestSortMeeting,
        sortByMeeting,
        sortTypeMeeting,
        dataMeeting,
        renderDataMeeting,
        headCellsMeeting,
        totalItemsMeeting

    } = ManageStateComplaintSubmitDetail()

    const handleChangeProjectTabs = (event: React.SyntheticEvent, newValue: number) => set_step(newValue)
    const hidden_button = (status: string, mode: "DRAFT" | "CONFIRM" | "APPROVE" | "REJECT"): boolean => {
        let validate_check: boolean = true;
        if (view) {
            return validate_check = true
        }
        if (mode === 'DRAFT') {
            if (status === COMPLAINTS_STATUS.DRAFT) {
                validate_check = false
            }
        }
        if (mode === 'CONFIRM') {
            if (status === COMPLAINTS_STATUS.DRAFT) {
                validate_check = false
            }
        }
        if (mode === "APPROVE") {
            if (cms && status === COMPLAINTS_STATUS.SUBMIT_COMPLAINT) {
                validate_check = false;
            }
        }
        if (mode === "REJECT") {
            if (cms && status === COMPLAINTS_STATUS.SUBMIT_COMPLAINT) {
                validate_check = false;
            }
        }
        return validate_check
    }
    return (
        <ContainerLayout
            title={id ? t("COMPLAINTS_SUBMIT_LIST") : t("COMPLAINTS_CREATE_SUBMIT_LIST")}
            {...(id && status ? {
                subTitle: <StatusCustom
                    // sx={{ width: 300 }}
                    disableMaxWidth
                    text={t(`${COMPLAINTS_STATUS_DATA.find((x) => x.value === status)?.label || ""}`)}
                    type={t(`${COMPLAINTS_STATUS_DATA.find((x) => x.value === status)?.label || ""}`)}
                />
            } : {})}
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            seq: 1,
                            key: "CANCEL",
                            label: cms ? t("COMPLAINTS_GO_BACK") : t("COMPLAINTS_CANCEL"),
                            type: "CANCEL",
                            buttonProps: {
                                onClick: () => navigate(-1)
                            }
                        },
                        {
                            seq: 2,
                            hidden: view || cms || hidden_button(status, 'DRAFT'),
                            key: "SAVE_DRAFT",
                            label: t("COMPLAINTS_SAVE_DRAFT"),
                            type: "SAVE_DRAFT",
                            buttonProps: {
                                disabled: !formState.id_group || !formState.complaint_title,
                                onClick: () => handleSubmit("DRAFT")
                            }
                        },
                        {
                            seq: 3,
                            hidden: view || cms || hidden_button(status, 'CONFIRM'),
                            key: "CONFIRM",
                            label: t("COMPLAINTS_CONFIRM"),
                            type: "CONFIRM",
                            buttonProps: {
                                disabled: !formState.id_group || !formState.complaint_title,
                                onClick: () => handleSubmit("SUBMIT")
                            }
                        },
                        {
                            seq: 4,
                            hidden: view || hidden_button(status, 'APPROVE'),
                            key: "APPROVE",
                            label: t("COMPLAINTS_ACCEPT"),
                            type: "APPROVE",
                            buttonProps: {
                                onClick: () => id && handleApprove && handleApprove(+id, () => {
                                    handleGetDetail(+id)
                                })
                            }
                        },
                        {
                            seq: 5,
                            hidden: view || hidden_button(status, 'REJECT'),
                            key: "REJECT",
                            label: t("COMPLAINTS_REJECT"),
                            type: "REJECT",
                            buttonProps: {
                                onClick: () => id && handleReject && handleReject(+id, () => {
                                    handleGetDetail(+id)
                                })
                            }
                        },
                        {
                            seq: 6,
                            hidden: !status_log_check.includes(status),
                            key: "TIMELINE",
                            label: "Timeline",
                            type: "TIMELINE",
                            buttonProps: {
                                onClick: () => handleOpenModal("LOG")
                            }
                        },
                        {
                            seq: 7,
                            hidden: view || !status_receive_check.includes(status),
                            key: "MEETING",
                            label: t("COMPLAINTS_SCHEDULE_MEETING"),
                            type: "MEETING",
                            buttonProps: {
                                onClick: () => id && !isNaN(+id) && handleSendMeeting(+id)
                            }
                        },
                        {
                            seq: 8,
                            hidden: view || !status_receive_check.includes(status),
                            key: "APPROVE2",
                            label: t("COMPLAINTS_SUMMARY_RESULT"),
                            type: "APPROVE",
                            buttonProps: {
                                onClick: () => handleOpenModal("INFER")
                            }
                        },
                    ]}
                />
            }
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_COMPLAINT_SYSTEM"),
                                disabled_match: true,
                                pathName: routeName.students.complaintSubmit,
                            },
                            ...(cms ? [
                                {
                                    key: "complaintSubmit",
                                    name: checkStatistics ? t("COMPLAINTS_STATISTICS") : t("COMPLAINTS_MANAGE_DATA"),
                                    pathName: checkStatistics ? routeName.cms.complaintsStatistics : routeName.cms.complaintSystem
                                },
                                ...(view ? [
                                    {
                                        key: "complaintSubmit",
                                        name: t("COMPLAINTS_DETAIL"),
                                        pathName: routeName.cms.complaintSystemDetailView.replace(":id", `${id}`)
                                    },
                                ] : [
                                    {
                                        key: "complaintSubmit",
                                        name: t("COMPLAINTS_DETAIL"),
                                        pathName: routeName.cms.complaintSystemDetail.replace(":id", `${id}`)
                                    },
                                ])

                            ] : [
                                {
                                    key: "complaintSubmit",
                                    name: t("COMPLAINTS_SUBMIT_COMPLAINT"),
                                    pathName: routeName.students.complaintSubmit
                                },
                                {
                                    key: "complaintSubmit",
                                    name: id ? t("COMPLAINTS_SUBMIT_LIST") : t("COMPLAINTS_CREATE_SUBMIT_LIST"),
                                    pathName: (id && !view) ?
                                        routeName.students.complaintSubmitDetail.replace(":id", id) :
                                        (view && id) ?
                                            routeName.students.complaintSubmitDetailView.replace(":id", id) :
                                            routeName.students.complaintSubmitCreate
                                },
                            ]),

                        ]
                    }
                />
            }
            content={
                <div className='w-full' >
                    {status_not_receive_check.includes(status) && (
                        <>
                            {/* <StepperCustom
                                setStep={(st) => set_step(st)}
                                step={step}
                                sx={{ maxWidth: 600 }}
                                view={true}
                                stepLabel={[
                                    {
                                        name: "รายละเอียด",
                                        isAccept: true
                                    },
                                    {
                                        name: "สรุปผล",
                                        isAccept: true
                                    },
                                ]}
                            /> */}
                            <Tabs
                                TabIndicatorProps={{ sx: { backgroundColor: colors.white, display: "flex", flexWrap: "wrap" } }}
                                value={step}
                                onChange={handleChangeProjectTabs}
                                aria-label="project-tabs">
                                {[t("COMPLAINTS_DESCRIPTION"), t("COMPLAINTS_SUMMARY"), ((dataMeeting?.length > 0 && cms && status_meeting_check.includes(status) ? t("COMPLAINTS_MEETING_INFORMATION") : ""))].filter((x) => x).map((list, index: number) => (
                                    <CustomTab label={<Typography sx={{
                                        color: step === index ? colors.white : colors.black
                                    }}>{list}</Typography>} {...projectTabsProps(index)} />
                                ))}
                            </Tabs>
                        </>
                    )}
                    {/* {status_receive_check.includes(status) && (
                        <StepperCustom
                            setStep={(st) => set_step(st)}
                            step={step}
                            sx={{ maxWidth: 600 }}
                            view={cms}
                            stepLabel={[
                                {
                                    name: "รอตอบรับเรื่องร้องเรียน",
                                    isAccept: true,
                                    iconOther: <IconComponent.SMSIcon />

                                },
                                {
                                    name: "อยู่ระหว่างตรวจสอบ",
                                    isAccept: true
                                },
                                {
                                    name: "สรุปผล",
                                    isAccept: true
                                },
                            ]}
                        />
                    )} */}

                    {
                        step === 0 && (
                            <>
                                <StateComponents
                                    sxContainer={{ mt: 3 }}
                                    disabledAllField={view || cms}
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "AUTO-COMPLETE",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                heading: t("COMPLAINTS_COMPLAINT_CATEGORY"),
                                                getOptionLabel: (op) => op?.complaints_type_name || "",
                                                labelId: "id_group",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                required: true,
                                                onChange: (_, val) => set_id_complaints_type(val),
                                                options: complaint_type_data || [],
                                                value: id_complaints_type
                                            }
                                        },
                                    ]}
                                />
                                <StateComponents
                                    disabledAllField={view || cms}
                                    otherProps={{ spacing: 2 }}
                                    heading={t("COMPLAINTS_INFORMATION")}
                                    sxContainer={{ mt: 4 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                onChange: (e) => handleChangeFormState('complaint_title', e.target.value),
                                                value: formState.complaint_title,
                                                required: true,
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                heading: t("COMPLAINTS_INFORMATION")
                                            }
                                        },
                                        {
                                            seq: 2,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                multiline: true,
                                                disablePaddingMultiline: true,
                                                row: 4,
                                                maxRows: 4,
                                                inputHeight: "auto",
                                                onChange: (e) => handleChangeFormState('complaint_detail', e.target.value),
                                                value: formState.complaint_detail,
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                heading: t("COMPLAINTS_WITH_DETAILS")
                                            }
                                        },
                                    ]}
                                />


                                <StateComponents
                                    disabledAllField={view || cms}
                                    heading={t("COMPLAINTS_PERSONAL_INFO")}
                                    sxContainer={{ mt: 4 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "RADIO",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                row: true,
                                                onChange: (e) => handleChangeFormState('is_publish', e.target.value === ComplaintPublishStatus.PUBLISHED ? true : false),
                                                value: formState.is_publish ? ComplaintPublishStatus.PUBLISHED : ComplaintPublishStatus.UNPUBLISHED,
                                                dataList: ComplaintPublishStatusData.map((list) => {
                                                    return {
                                                        ...list,
                                                        label: t(list.label)
                                                    }
                                                })
                                            }
                                        },
                                    ]}
                                />
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    disabledAllField
                                    typeProps={[
                                        {
                                            seq: 2,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 3
                                            },
                                            fieldProps: {
                                                onChange: () => "",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                value: languageEnum.TH === currentLanguage ? formState.first_name : formState.first_name_eng,
                                                heading: t("COMPLAINTS_FIRST_NAME")
                                            }
                                        },
                                        {
                                            seq: 3,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 3
                                            },
                                            fieldProps: {
                                                onChange: () => "",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                heading: t("COMPLAINTS_LAST_NAME"),
                                                value: languageEnum.TH === currentLanguage ? formState.last_name : formState.last_name_eng,
                                            }
                                        },
                                        {
                                            seq: 4,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 3
                                            },
                                            fieldProps: {
                                                onChange: () => "",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                heading: formState?.id_student ? t("COMPLAINTS_STUDENT_ID") : t("COMPLAINTS_STAFF_ID"),
                                                value: formState?.employee_no
                                                // value: languageEnum.TH === currentLanguage ? formState.last_name : formState.last_name_eng,
                                            }
                                        },
                                        {
                                            seq: 4,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 3
                                            },
                                            fieldProps: {
                                                onChange: () => "",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                heading: t("COMPLAINTS_PASSPORT_NUMBER"),
                                                value: formState?.id_card
                                            }
                                        },

                                        // นักศึกษา จะเป็นหลักสูตร
                                        {
                                            seq: 5,
                                            type: "AUTO-COMPLETE",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                heading: formState?.id_student ? t("COMPLAINTS_PROGRAM") : t("COMPLAINTS_CURRENT_POSITION"),
                                                getOptionLabel: (op) => formState?.id_student ? op?.faculty_name || "" : "",
                                                labelId: "faculty",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                onChange: () => { },
                                                options: formState?.id_student ? [formState.faculty] : [],
                                                value: formState?.id_student ? formState.faculty : null
                                            }
                                        },
                                        {
                                            seq: 6,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                onChange: () => "",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                heading: t("COMPLAINTS_PHONE_NUMBER"),
                                                value: formState.phone_number
                                            }
                                        },
                                        {
                                            seq: 7,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                onChange: () => "",
                                                placeholder: t("COMPLAINTS_SPECIFY"),
                                                heading: t("COMPLAINTS_EMAIL"),
                                                value: formState.email
                                            }
                                        },
                                        {
                                            seq: 8,
                                            type: "COMPONENT",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                element: (
                                                    <div className='w-full'>
                                                        <ImageTracking
                                                            enableAllType
                                                            disabled={view || hidden_button(status, 'DRAFT')}
                                                            heading={t("COMPLAINTS_ATTACHMENT")}
                                                            handleDeleteImageApi={(_, file_index) => handleDeleteImageApi(file_index)}
                                                            handleDeleteImageSelect={(_, file_index) => handleDeleteImageUploadFile(file_index)}
                                                            onChange={handleChangeImage}
                                                            handleShowImageWithIndex={(img_index) => handleGetFile(img_index)}
                                                            tabIndex={0}
                                                            valueAddFile={image_data}
                                                            onDownloadFileButton={(data) => handleDownloadFile(data?.id_complaints_file, data?.file?.type || "", data?.file?.name || "-")}
                                                            valueImage={complaints_files || []}
                                                        />
                                                    </div>
                                                )
                                            }
                                        },
                                    ]}
                                />

                            </>
                        )
                    }


                    {/* สรุป */}
                    {
                        step === 1 && (
                            <div className='w-full mt-4'>
                                <StateComponents
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12
                                            },

                                            fieldProps: {
                                                onChange: () => { },
                                                row: 5,
                                                maxRows: 5,
                                                heading: t("COMPLAINTS_NOTE"),
                                                disabled: true,
                                                disablePaddingMultiline: true,
                                                inputHeight: 'auto',
                                                multiline: true,
                                                value: dataDetail?.complaints_result || ""
                                            }
                                        }
                                    ]}
                                />

                                {status_image_infer.includes(status) && (
                                    <ImageTracking
                                        enableAllType
                                        disabled={true}
                                        // disabled={view || hidden_button(status, 'DRAFT')}
                                        heading={t("COMPLAINTS_ATTACHMENT")}
                                        handleDeleteImageApi={() => { }}
                                        handleDeleteImageSelect={() => { }}
                                        onChange={() => { }}
                                        // handleShowImageWithIndex={(img_index) => handleGetFile(img_index)}
                                        tabIndex={3}
                                        valueAddFile={[]}
                                        onDownloadFileButton={(data) => handleDownloadFile(data?.id_complaints_file, data?.file?.type || "", data?.file?.name || "-")}
                                        valueImage={file_infer_api || []}
                                    />
                                )}
                                <div className='flex justify-end items-center my-5 gap-4'>
                                    <span>
                                        {t("COMPLAINTS_DATE")} : {dataDetail?.modified_date ? moment(dataDetail?.modified_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : "-"}
                                    </span>
                                    <span>
                                        {t("COMPLAINTS_TIME")} : {dataDetail?.modified_date ? moment(dataDetail?.modified_date).format("HH:mm") : "-"}
                                    </span>
                                </div>


                            </div>
                        )
                    }


                    {step === 2 && (
                        <section className='w-full mt-10'>
                            <TableCustom
                                tableMinWidth={1040}
                                tableFixedWidth
                                customScroll
                                page={pageMeeting}
                                pageLimit={pageLimitMeeting}
                                sortBy={sortByMeeting}
                                sortType={sortTypeMeeting}
                                headCells={headCellsMeeting}
                                rowCount={totalItemsMeeting}
                                rowsData={dataMeeting?.map((data: any, i: any) => {
                                    return renderDataMeeting(data, i)
                                })}
                                onSort={handleRequestSortMeeting}
                                setPageLimit={(value: number) => setPageLimitMeeting(value)}
                                setPage={(value: number) => setPageMeeting(value)}
                            />
                        </section>
                    )}


                    <ContainerButton
                        sxContainer={{ my: 8 }}
                        justifyContent='center'
                        buttonData={[
                            {
                                seq: 1,
                                key: "CANCEL",
                                label: cms ? t("COMPLAINTS_GO_BACK") : t("COMPLAINTS_CANCEL"),
                                type: "CANCEL",
                                buttonProps: {
                                    onClick: () => navigate(-1)
                                }
                            },
                            {
                                seq: 2,
                                hidden: view || cms || hidden_button(status, 'DRAFT'),
                                key: "SAVE_DRAFT",
                                label: t("COMPLAINTS_SAVE_DRAFT"),
                                type: "SAVE_DRAFT",
                                buttonProps: {
                                    disabled: !formState.id_group || !formState.complaint_title,
                                    onClick: () => handleSubmit("DRAFT")
                                }
                            },
                            {
                                seq: 3,
                                hidden: view || cms || hidden_button(status, 'CONFIRM'),
                                key: "CONFIRM",
                                label: t("COMPLAINTS_CONFIRM"),
                                type: "CONFIRM",
                                buttonProps: {
                                    disabled: !formState.id_group || !formState.complaint_title,
                                    onClick: () => handleSubmit("SUBMIT")
                                }
                            },
                            {
                                seq: 4,
                                hidden: COMPLAINTS_STATUS.WAIT_APPROVE !== status || view,
                                key: "APPROVE",
                                label: t("COMPLAINTS_APPROVE"),
                                type: "APPROVE",
                                buttonProps: {
                                    onClick: () => id && !isNaN(+id) && handleApproveAndRejectInfer(+id, 'APPROVE')
                                }
                            },
                            {
                                seq: 5,
                                hidden: COMPLAINTS_STATUS.WAIT_APPROVE !== status || view,
                                key: "RETURN",
                                label: t("COMPLAINTS_SEND_REVIEW"),
                                type: "RETURN",
                                buttonProps: {
                                    disabled: !formState.id_group || !formState.complaint_title,
                                    onClick: () => handleOpenModal("SEND_FOR_REVIEW")
                                }
                            },
                        ]}
                    />


                    {
                        show_time_line === "LOG" && (
                            <ModalCustom
                                open
                                title='Timeline'
                                subTitle={t('ประวัติการดำเนินการ')}
                                size="desktopXl"
                                maxWidth={1440}
                                onClose={handleCloseModal}
                                component={
                                    <div className='mt-10 w-full'>
                                        <section className='w-full mt-10'>
                                            <TableCustom
                                                tableMinWidth={1440}
                                                tableFixedWidth
                                                customScroll
                                                page={page}
                                                pageLimit={pageLimit}
                                                sortBy={sortBy}
                                                sortType={sortType}
                                                headCells={headCells}
                                                rowCount={totalItems}
                                                rowsData={data_time_line?.map((data: any, i: any) => {
                                                    return renderData(data, i)
                                                })}
                                                onSort={handleRequestSort}
                                                setPageLimit={(value: number) => setPageLimit(value)}
                                                setPage={(value: number) => setPage(value)}
                                            />
                                        </section>
                                    </div>
                                }
                            />
                        )
                    }

                    {show_time_line === 'SEND_FOR_REVIEW' && (
                        <ModalCustom
                            open
                            title={t("COMPLAINTS_SEND_REVIEW")}
                            subTitle={t("COMPLAINTS_PLEASE_SPECIFY_NOTE")}
                            size="md"
                            maxWidth={1040}
                            onClose={handleCloseModal}
                            containerButton={{
                                onClose: handleCloseModal,
                                disabled_submit: !remark,
                                onSubmit: () => id && !isNaN(+id) && handleApproveAndRejectInfer(+id, 'REJECT')
                            }}
                            component={
                                <div className='mt-10 w-full z-40 flex flex-col gap-5'>
                                    <StateComponents
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    onChange: (e) => set_remark(e.target.value),
                                                    heading: t("COMPLAINTS_DESCRIPTION"),
                                                    placeholder: t("COMPLAINTS_SPECIFY"),
                                                    disablePaddingMultiline: true,
                                                    multiline: true,
                                                    row: 5,
                                                    maxRows: 5,
                                                    required: true,
                                                    value: remark,
                                                    inputHeight: "auto",
                                                }
                                            },
                                        ]}
                                    />
                                </div>
                            }
                        />
                    )}
                    {
                        show_time_line === 'INFER' && (
                            <ModalCustom
                                open
                                title={t("COMPLAINTS_SUMMARY_RESULT")}
                                subTitle={t("COMPLAINTS_PLEASE_SPECIFY_DETAIL")}
                                size="desktopXl"
                                maxWidth={1440}
                                onClose={handleCloseModal}
                                containerButton={{
                                    onClose: handleCloseModal,
                                    onSubmit: () => id && handleSubmitInfer(+id)
                                }}
                                component={
                                    <div className='mt-10 w-full z-40 flex flex-col gap-5'>
                                        <StateComponents
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        onChange: (e) => set_remark(e.target.value),
                                                        heading: t("COMPLAINTS_DESCRIPTION"),
                                                        placeholder: t("COMPLAINTS_SPECIFY"),
                                                        disablePaddingMultiline: true,
                                                        multiline: true,
                                                        row: 5,
                                                        maxRows: 5,
                                                        value: remark,
                                                        inputHeight: "auto",

                                                    }
                                                },
                                            ]}
                                        />
                                        <ImageTracking
                                            enableAllType
                                            disabled={view}
                                            // disabled={view || hidden_button(status, 'DRAFT')}
                                            heading={t("COMPLAINTS_ATTACHMENT")}
                                            handleDeleteImageApi={() => { }}
                                            handleDeleteImageSelect={(_, file_index) => handleDeleteImageUploadFileInfer(file_index)}
                                            onChange={handleChangeImageInfer}
                                            // handleShowImageWithIndex={(img_index) => handleGetFile(img_index)}
                                            tabIndex={1}
                                            valueAddFile={file_infer}
                                            valueImage={[]}
                                        />
                                    </div>
                                }
                            />
                        )
                    }
                </div >
            }
        />
    )
}

export default ComplaintSubmitDetail